/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Profile role enumeration for user access within an account.
 */
export type ProfileRole = typeof ProfileRole[keyof typeof ProfileRole];


export const ProfileRole = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
} as const;
